import React from 'react'
import { connect } from 'react-redux'
import {
  askConfirmationUpdate,
  cancelDelete,
  deletePromo,
  hideDeleteModal,
  promoPageRequest,
  setActionUpdateName
} from 'actions/library/promo'
import { ContentWrapper, LeftColumnWrapper, PageWrapper, RightColumnWrapper } from 'components/wrappers/pages'
import ActionBar from './ActionBar'
import List from './List'
import DetailPromo from './DetailPromo'
import NoDataAndLoading from 'components/NoDataAndLoading'
import { askConfirmAction } from 'actions/confirm-action'
import { isDirty } from 'redux-form'
import { browserHistory } from 'react-router'
import { push } from 'react-router-redux'
import ConfirmActionModal from 'components/ConfirmActionModal'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import DeactivateModal from './DeactivateModal'
import ReactivateModal from './ReactivateModal'
import ConfirmReactivateModal from './ConfirmReactivateModal'
import UpdateConfirmationModal from './UpdateConfirmationModal'
import { libraryPromoDeleteReactivateDeactivate, libraryPromoStart } from 'mixpanel/library/promo'
import { mapKeys } from 'lodash'
import { hidePromoLibrary, shouldShowPromoLibrary } from 'utils/ftue'

class Promo extends React.Component {

  render () {
    let {openRightColumn, showLoadingSpinnerPage, promos, showDeleteModal, deletedPromo} = this.props
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={promos.length === 0}
              title='No Data To Display'
              description=''
              linkLabel={'Create Promo'}
              linkUrl={'https://mokaposhelp.zendesk.com/hc/en-us/articles/115004527873-Create-Promo'}
            />
            {promos.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <DetailPromo />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title='Promo'
          name={deletedPromo ? deletedPromo.name : ''}
          onDelete={this._onDelete}
        />
        <DeactivateModal />
        <ReactivateModal />
        <ConfirmReactivateModal />
        <UpdateConfirmationModal />
      </PageWrapper>
    )
  }

  componentDidMount () {
    libraryPromoStart()
    const {expired} = this.props
    if (!expired) {
      this.props.dispatch(promoPageRequest())
      browserHistory.listenBefore((location) => {
        if ((this.props.isDirtyPromoTypeName || this.props.isDirtyPromoConfiguration) && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  componentWillUnmount () {
    if (shouldShowPromoLibrary()) {
      hidePromoLibrary()
    }
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete())
  }

  _onDelete = () => {
    const {deletedPromo, promos, dispatch, isManager, hashedPromoType, outlets} = this.props
    let hashedOutlets = mapKeys(outlets, 'id')
    const outletNames = []
    deletedPromo.outlet_ids.forEach(oId => {
      if (hashedOutlets[oId]) {
        outletNames.push(hashedOutlets[oId].name)
      }
    })
    libraryPromoDeleteReactivateDeactivate('Promo Delete', {
      promoType: hashedPromoType[deletedPromo.promo_type_id].name,
      promoName: deletedPromo.name,
      outlet: outletNames
    })
    if (isManager) {
      dispatch(setActionUpdateName('delete'))
      dispatch(hideDeleteModal())
      dispatch(askConfirmationUpdate(deletePromo(deletedPromo.id, promos)))
    } else {
      dispatch(deletePromo(deletedPromo.id, promos))
    }
  }
}

function mapStateToProps (state) {
  const {openRightColumn, promos, showDeleteModal, deletedPromo, promoTypes, outlets} = state.library.promo
  const hashedPromoType = mapKeys(promoTypes, 'id')
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {nextAction} = state.confirmAction
  const isManager = state.moka.user.is_manager
  const {expired} = state.subscriptionExpired
  return {
    openRightColumn,
    showLoadingSpinnerPage,
    isDirtyPromoTypeName: isDirty('promoTypeAndName')(state),
    isDirtyPromoConfiguration: isDirty('promoConfig')(state),
    nextAction,
    promos,
    showDeleteModal,
    deletedPromo,
    isManager,
    hashedPromoType,
    outlets,
    expired
  }
}

export default connect(mapStateToProps)(Promo)




// WEBPACK FOOTER //
// ./app/pages/Library/Promo/Promo.js